export const propertyOnTheMapDict = {
  en: {
    location: 'Location',
  },
  de: {
    location: 'Standort',
  },
  ru: {
    location: 'Местоположение',
  },
  tr: {
    location: 'Konum',
  },
};
